/**
 * @generated SignedSource<<813fc3005b56e5f4dd671a862d3f6c53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportAverageEventsFeedbackStatisticCardFragment$data = {
  readonly averageEventsFeedbackReport: {
    readonly allTime: number;
  };
  readonly " $fragmentType": "MemberReportAverageEventsFeedbackStatisticCardFragment";
};
export type MemberReportAverageEventsFeedbackStatisticCardFragment$key = {
  readonly " $data"?: MemberReportAverageEventsFeedbackStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportAverageEventsFeedbackStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportAverageEventsFeedbackStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "AverageEventFeedbackReportResponse",
      "kind": "LinkedField",
      "name": "averageEventsFeedbackReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "6164a29d46207eaed8b6db8a29f147a5";

export default node;
